module.exports = __webpack_public_path__ + "img/9788956590486.3afe2ede.jpg";